import { httpClient } from "@/services/HttpClient";
import { eventEmitter } from "@/utils/eventEmitter";
class Music {
    /** @type {PlaylistPreview[] | null} */
    _playlists = null;
    addTrackToPlaylists(trackId, playlistsIds) {
        return httpClient.fetch('/api/v1/playlists', {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                trackId,
                playlistsIds,
            })
        });
    }
    checkTrackStatus(trackId) {
        return httpClient.fetch(`/api/v1/tracks/${trackId}/status`);
    }
    /** Создает плейлист
     * payload - FormData c полями title (string) и avatar (file)
     * @param {CreatePlaylistPayload} payload
     * */
    createPlaylist(payload) {
        return httpClient.fetch('/api/v1/playlists', {
            method: 'POST',
            body: payload,
        });
    }
    deleteFromPlaylist(trackId, playlistId) {
        return httpClient.fetch(`/api/v1/playlists/tracks/${trackId}?playlist_id=${playlistId}`, {
            method: 'DELETE',
        });
    }
    /** @param {Playlist.id} playlistId  */
    loadPlaylist(playlistId) {
        return httpClient.fetch(`/api/v1/playlists/${playlistId}`);
    }
    /**
    * @param {number} [userId]
    * @returns {ServiceMethodReturn}
    * */
    loadPlaylists(userId) {
        return this.#getPlaylists(userId);
    }
    /** @param {PlaylistPreview[] | null} v */
    set playlists(v) {
        eventEmitter.emit('playlists change', { postponed: true, data: v });
        this._playlists = v;
    }
    get playlists() {
        return this._playlists;
    }
    uploadTrack(payload) {
        return httpClient.fetch('/api/v1/tracks', {
            method: 'POST',
            body: payload,
        });
    }
    #getPlaylists(userId) {
        let url = `/api/v1/playlists`;
        if (userId)
            url += `?user_id=${userId}`;
        return httpClient.fetch(url);
    }
}
export const music = new Music();
